import { Box, Button, Grid, Paper, Typography } from '@material-ui/core'
import { useContext, useState } from 'react'
import { RootContext } from '../../..'
import { IGetPurchaseOrderPendingReceiveProduct } from '../../../api/smartbestbuys-api'
import { FilteredTable, Link, Topic, withLayout } from '../../../custom-components'
import { PageName, ProductType } from '../../../enums'
import { dateFormat, dateTimeFormat } from '../../../functions'
import { usePurchaseOrderPendingReceiveProduct } from '../../../hooks'
import PendingReceiveProductDialog from '../../warehouse/receive-product-tasks-list/PendingReceiveProductDialog'

const WarehousePendingReceiveProductListPage = () => {
  // root context
  const { setCurrentPage } = useContext(RootContext)
  setCurrentPage(PageName.PURCHASE_FOLLOW_SERVICE_TASK)

  // state

  const [selectPurchaseOrderId, setSelectPurchaseOrderId] = useState<number | undefined>(undefined)
  const [reload, setReload] = useState(false)

  // hook
  const purchaseOrders = usePurchaseOrderPendingReceiveProduct(ProductType.Service, reload)

  return (
    <Box p={2}>
      {selectPurchaseOrderId && (
        <PendingReceiveProductDialog
          open={!!selectPurchaseOrderId}
          purchaseOrderId={selectPurchaseOrderId}
          onComplete={() => {
            setReload((prev) => !prev)
          }}
          onClose={() => {
            setSelectPurchaseOrderId(undefined)
          }}
        />
      )}
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Topic>รายงานการติดตามบริการ</Topic>
        </Grid>
        <Grid item xs={12}>
          <Paper>
            <FilteredTable<IGetPurchaseOrderPendingReceiveProduct>
              color="primary.dark"
              columns={[
                {
                  name: 'ติดตามบริการ',
                  dataIndex: 'code',
                  render: ({ id }) => (
                    <Button
                      variant="contained"
                      color="primary"
                      classes={{ label: 'px-2 leading-none' }}
                      onClick={() => setSelectPurchaseOrderId(id)}
                    >
                      ติดตามบริการ
                    </Button>
                  ),
                },
                {
                  name: 'ใบสั่งซื้ออ้างอิง',
                  dataIndex: 'code',
                  render: ({ id, code }) => (
                    <Link color="primary" to={`/purchase-orders/${id}/profile`} target="_blank">
                      <Box color="primary.dark">
                        <Typography variant="body2">{code}</Typography>
                      </Box>
                    </Link>
                  ),
                },
                {
                  name: 'วันที่นัดส่งสินค้า',
                  render: ({ vendorShippingDate }) => (!!vendorShippingDate ? dateFormat(vendorShippingDate) : '-'),
                },
                {
                  name: 'ชื่อผู้ขาย',
                  render: ({ vendor }) => vendor.name,
                },
                {
                  name: 'วันที่สร้าง',
                  render: ({ recCreatedAt }) => dateTimeFormat(recCreatedAt),
                },
              ]}
              sortable
              data={purchaseOrders}
              disableDateRangeFilter
            />
          </Paper>
        </Grid>
      </Grid>
    </Box>
  )
}

export default withLayout(WarehousePendingReceiveProductListPage)
